import { Injectable } from '@angular/core';
import { filter, sortBy } from 'lodash';
import { bcEnums } from 'common/common/constants/boldchat-enums';
import { OperatorsService } from 'common/operators/operators.service';
import { ActiveWorkItemCountModel } from 'common/api/models/active-work-item-count.model';
import { ItemType } from 'shared/components/operators-list/item-type';

@Injectable()
export class OperatorsListService {

  constructor(private _operatorsService: OperatorsService) { }

  public getDepartmentOperatorAvailabilityList() {
    return this._operatorsService.getOperatorsAndDepartmentsWithAvailability()
      .then(departments => {
        departments.forEach(dep => {
          dep.unfilteredOperatorCount = dep.operators ? dep.operators.length : 0;
          dep.collapsed = true;
        });
        return departments;
      })
      .then(departments => {
        return sortBy(departments, 'name');
      });
  }

  public buildListFilteredByName(departments, name) {
    const filteredList = [];
    departments.forEach(department => {
      const isDepartmentFiltered = this._isItemFiltered(department, name);
      if (!isDepartmentFiltered || this._hasUnfilteredItem(department.operators, name)) {
        filteredList.push({
          type: ItemType.DEPARTMENT_ITEM_TYPE,
          item: department
        });
      }
      if (!department.collapsed) {
        department.operators.forEach(operator => {
          if (!isDepartmentFiltered || !this._isItemFiltered(operator, name)) {
            filteredList.push({
              type: ItemType.OPERATOR_ITEM_TYPE,
              item: operator
            });
          }
        });
      }
    });
    return filteredList;
  }

  private _isItemFiltered(item, filterString) {
    if (!item) {
      return true;
    }
    if (!filterString) {
      return false;
    }
    return (item.name || '').toLocaleLowerCase().indexOf(filterString.toLocaleLowerCase()) === -1;
  }

  private _hasUnfilteredItem(itemList, filterString) {
    if (!itemList) {
      return false;
    }
    if (!filterString) {
      return !!itemList.length;
    }
    return itemList.some(item => {
      return !this._isItemFiltered(item, filterString);
    });
  }

  public filterOfflineOperators(departments, workItemType) {
    const workItemAvailabilityKey = workItemType.toLowerCase();
    departments.forEach((department) => {
      department.operators = filter(department.operators, (operator: any) => {
        return operator.availability[workItemAvailabilityKey] !== bcEnums.statuses.OFFLINE;
      });
    });
    return departments;
  }

  public getActiveChatCounts(): Promise<ActiveWorkItemCountModel[]> {
    return this._operatorsService.getActiveChatCounts();
  }

  public getActiveTextChatCounts(): Promise<ActiveWorkItemCountModel[]> {
    return this._operatorsService.getActiveTextChatCounts();
  }
}
